/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Sc_UndoInputs */

const en_pc_tut_sc_undo = /** @type {(inputs: Pc_Tut_Sc_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const zh_pc_tut_sc_undo = /** @type {(inputs: Pc_Tut_Sc_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撤销`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Pc_Tut_Sc_UndoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_sc_undo = /** @type {((inputs?: Pc_Tut_Sc_UndoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Sc_UndoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_sc_undo(inputs)
	return zh_pc_tut_sc_undo(inputs)
});
export { pc_tut_sc_undo as "pc.tut.sc.undo" }